import React, { useState, useEffect, useContext } from "react";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";


import folderImg from "../../assets/icons/folder_bread_crump.png";
import staffImg from '../../assets/icons/accountGroup.png';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import PlaylistAddCheckCircleOutlinedIcon from '@mui/icons-material/PlaylistAddCheckCircleOutlined';

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import {
  CLIENT_GROUP_LIST_QUERY,
  DELETE_GROUP_MUTATION

} from "../../graphQL/group_qry";

import { GET_CLIENT_UUID } from "../../graphQL/client_qry";

import Header from "./Header.js";

import AlertDialog from "../../components/AlertDialog.js";

import GroupStaffListDialog from "./groupStaffListDialog.js";

import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  largeButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#4080ad",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function GroupList() {
  
  //const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);

  const [clientUuid, setClientUuid] = useState("");
  const [groupUuid, setGroupUuid] = useState("");
  const [groupName, setGroupName] = useState("");

  const [clientGroupList, setClientGroupList] = useState([]);

  const [groupStaffListDialog, setGroupStaffListDialog] = useState(false);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  let loadData = true;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");
  if (clientId == 0)
    loadData = false;

  let clientName = "";
  if (localStorage.getItem("clientName")) 
    clientName = localStorage.getItem("clientName");

  
  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [permissionsAccess, setPermissionsAccess] = useState(false);
  const [staffAccess, setStaffAccess] = useState(false);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage Groups"     
            },
          });
    
    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
      if(additionalActions.find(a => a == "Configure Group Permissions"))
        setPermissionsAccess(true)
      if(additionalActions.find(a => a == "Staff"))
        setStaffAccess(true)
                
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }  

  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);  


  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });


  const [fetchAllGroups] = useManualQuery(CLIENT_GROUP_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const [deleteGroupMutation] = useMutation(DELETE_GROUP_MUTATION, {
    fetchPolicy: "network-only",
  });


  const [getClientUuid] = useManualQuery(GET_CLIENT_UUID);
  const getCurrClientUuid = async () => {
    if (clientId != 0)
    {
          const {
          loading: loadingClientUuid,
          error: errorClientUuid,
          data: dataClientUuid,
        } = await getClientUuid({
          variables: {
            clientId: parseInt(clientId),
          },
        });
        if (!loadingClientUuid && dataClientUuid) {
          setClientUuid(dataClientUuid.getClientData.clientUuid);
        }
        if (errorClientUuid) {
          if (errorClientUuid.graphQLErrors[0].message === "Signature has expired")
            navigate(`${project_url}/signin/?next=${pathname}`);
        }
    }
    
  };
  useEffect(() => {
    (() => getCurrClientUuid())();
  }, [clientId]);

  const [alertActivateMsg, setAlertActivateMsg] = useState([]);



  const getGroupsList = async () => {
    const {
      loading: groupsListLoading,
      error: groupsListError,
      data: groupsListData,
    } = await fetchAllGroups({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!groupsListLoading && groupsListData && groupsListData.getAllClientGroups) {
      setClientGroupList(groupsListData.getAllClientGroups)
      
      loadData = true;
    }
    else 
      loadData = false;
    if (
      groupsListError &&
      groupsListError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin/?next=${pathname}`);
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getGroupsList())();
  }, []);



  function checkDeleteStatus(row) {
    if (row.deletable === false)
      setAlertDeleteMsg({
        title: "Delete Group",
        msg: 'The group "' + row.name + '" cannot be deleted, because it has related module permissions',});
    else
      setAlertDeleteMsg({
        title: "Delete Group",
        type: "deleteConfirmation",
        msg: "Are you sure you want to delete the group “" + row.name + "”?",
        groupId: row.id,
      });
  }

  const deleteGroup = async groupId => {
    const {
      loading: loadingGroupDelete,
      error: errorGroupDelete,
      data: dataGroupDelete,
    } = await deleteGroupMutation({
      variables: {
        groupId: parseInt(groupId),
      },
    });
    if (!loadingGroupDelete && dataGroupDelete && dataGroupDelete.deleteGroup) {
      getGroupsList();
    }
    if (errorGroupDelete) {
      if (errorGroupDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else alert(errorGroupDelete.graphQLErrors[0].message);
    }
  };

   const groupStaffFunc = async (groupUuid,groupName) => {

    setGroupUuid(groupUuid);
    setGroupName(groupName);
    setGroupStaffListDialog(true) ;
   }


  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,

    },

    {
      field: "desc",
      headerName: "Description",
      minWidth: 150,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,

    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editPath = `${project_url}/groups/` + rows.row.groupUuid;
        var permissionPath = `${project_url}/groups/` + rows.row.groupUuid + '/group-permissions';
        var groupUuid =  rows.row.groupUuid;
        var groupName =  rows.row.name;

        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        var permissionsCursor = rows.row.permissionsAccess ? "pointer" : "auto";

        var staffCursor = rows.row.staffAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Configure group permissions">
              <Box
                style={{
                  paddingRight: 15,
                  cursor: permissionsCursor,
                  height: 24,
                  weight: 24,
                }}>
              <PlaylistAddCheckCircleOutlinedIcon color={rows.row.permissionsAccess ? "action" : "disabled"}
               onClick={() => rows.row.permissionsAccess ? navigate(permissionPath) : ""}/>
              </Box>

              </StyledTooltip>

            <StyledTooltip title="Staff">
              <Box
                style={{
                  paddingRight: 15,
                  cursor: staffCursor,
                  height: 24,
                  weight: 24,
                }}>
              <Diversity2Icon color={rows.row.staffAccess ? "action" : "disabled"} 
              onClick={() => rows.row.staffAccess ? groupStaffFunc(groupUuid,groupName) : ""} />
              </Box>
            </StyledTooltip>

            <StyledTooltip title="Edit this group">
              <img
                style={{
                  paddingRight: 15,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                onClick={() => rows.row.editAccess ? navigate(editPath) : ""}
              />
            </StyledTooltip>
            <StyledTooltip title="Delete this group">
              <img
                style={{
                  paddingRight: 15,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                onClick={() => rows.row.deleteAccess ? checkDeleteStatus(rows.row):""}
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  var rows = clientGroupList.map(currGroup => ({
        id : currGroup.groupId,
        groupUuid : currGroup.groupUuid,
        name : currGroup.name,
        desc : currGroup.desc,
        deletable : currGroup.deletable,
        editAccess : editAccess,
        deleteAccess : deleteAccess,
        permissionsAccess : permissionsAccess,
        staffAccess : staffAccess
                
  }));


  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Manage Groups
            </Typography>
          </Grid>

          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled = {!addAccess ? "disabled" : ""}
              onClick={() => addAccess ? navigate(`${project_url}/groups/add`):""}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  if (loadContent)
  if (loadData)
  if (access)
    return (
      <div className={classes.root}>
        <Header />
        <div className={classes.container}>
          <PersistentDataGrid
            persistenceKey="manage-groups"
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
              sorting: {
                sortModel: [{ field: "endDate", sort: "desc" }],
              },
            }}
            pageSizeOptions={[10, 25, 50]}

          />
          <style>
            {`
              .current-row {
                background-color: rgba(203, 255, 139, 0.33) !important; /* Light green */
              }
            `}
          </style>

         {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteGroup(alertDeleteMsg.groupId);
              }}
            />
          )}

          {groupStaffListDialog && (
            <GroupStaffListDialog
              closeDialog={() => setGroupStaffListDialog(false)}
              groupUuid={groupUuid}
              groupName={groupName}
            />
          )}


        </div>
      </div>
    );

    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
   else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Client"
                contentMsg='There is no client in this Tenant. Please create a client.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );

  else return;
  
}

export default GroupList;
